angular.module('impactx.product').controller('AddPriceListCtrl', ['$scope', '$mdDialog', 'themeFactory', 'data', 'priceGroup',
    'trns', 'orderUnit', 'allowFracAmounts', 'dataGen', AddPriceListCtrl]);

function AddPriceListCtrl($scope, $mdDialog, themeFactory, data, priceGroup, trns, orderUnit, allowFracAmounts, dataGen)
{
    $scope.theme = themeFactory.getTheme();
    $scope.trns = trns;
    $scope.orderUnit = orderUnit;
    $scope.allowFracAmounts = allowFracAmounts;
    this.init = function()
    {
        var startDate,
            endDate,
            dayOffset = 0,
            pliIndex;
        dataGen.getData({}, data, "/product/pricelist/new").then(function (response) {
            if (response && response.data) {
                $scope.priceListCopy = response.data;
                $scope.priceListCopy.shown = true;

                if(impactX.isDefined($scope.priceListCopy, 'startDate.dateValue')) {
                    startDate = new Date($scope.priceListCopy.startDate.dateValue);
                } else {
                    startDate = new Date();
                }

                if(dayOffset > 0) {
                    startDate.setDate(startDate.getDate() + dayOffset);
                }

                endDate = new Date(startDate);
                endDate.setFullYear(endDate.getFullYear() + 1);

                $scope.priceListCopy.startDate.dateValue = startDate.getTime();
                $scope.priceListCopy.endDate.dateValue = endDate.getTime();

                $scope.priceListCopy.deleted = false;

                for (pliIndex = 0; pliIndex < $scope.priceListCopy.priceListItems.length; pliIndex++)
                {
                    $scope.priceListCopy.priceListItems[pliIndex].id = 0;
                    $scope.priceListCopy.priceListItems[pliIndex].deleted = false;
                }
            }
        });
    };

    this.init();

    this.addPriceListItem = function(priceList)
    {
        var i = priceList.length - 1;
        while (i > 0)
        {
            if (!priceList[i].deleted)
            {
                break;
            }
            i--;
        }

        var priceListItemCopy = JSON.parse(JSON.stringify(priceList[i]));
        priceListItemCopy.id = 0;
        priceList.push(priceListItemCopy);
    };

    this.removePriceListItem = function(priceListItem)
    {
        priceListItem.deleted = true;
    };

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        var startDateValueNew = $scope.priceListCopy.startDate.dateValue;
        var endDateValueNew = $scope.priceListCopy.endDate.dateValue;
        var startDateNew = new Date(startDateValueNew);
        var endDateNew = new Date(endDateValueNew);
        var indexToPush = -1;
        var newDateOld;
        for (var i = 0; i < priceGroup.priceLists.length; i++)
        {
            var currComparePriceList = priceGroup.priceLists[i];
            if (!currComparePriceList.deleted)
            {
                if (startDateValueNew.getTime() <= currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() >= currComparePriceList.endDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i : indexToPush;
                    currComparePriceList.deleted = true;
                    continue;
                }
                if (startDateValueNew.getTime() == currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() < currComparePriceList.endDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i : indexToPush;
                    newDateOld = new Date(endDateNew);
                    newDateOld.setDate(endDateNew.getDate() + 1);
                    currComparePriceList.startDate.dateValue = newDateOld;
                    continue;
                }
                if (startDateValueNew.getTime() > currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() == currComparePriceList.endDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i + 1 : indexToPush;
                    newDateOld = new Date(startDateNew);
                    newDateOld.setDate(startDateNew.getDate() - 1);
                    currComparePriceList.endDate.dateValue = newDateOld;
                    continue;
                }
                if (startDateValueNew.getTime() < currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() < currComparePriceList.endDate.dateValue.getTime() &&
                    endDateValueNew.getTime() >= currComparePriceList.startDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i : indexToPush;
                    newDateOld = new Date(endDateNew);
                    newDateOld.setDate(endDateNew.getDate() + 1);
                    currComparePriceList.startDate.dateValue = newDateOld;
                    continue;
                }
                if (startDateValueNew.getTime() > currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() > currComparePriceList.endDate.dateValue.getTime() &&
                    startDateValueNew.getTime() <= currComparePriceList.endDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i + 1 : indexToPush;
                    newDateOld = new Date(startDateNew);
                    newDateOld.setDate(startDateNew.getDate() - 1);
                    currComparePriceList.endDate.dateValue = newDateOld;
                    continue;
                }

                if (startDateValueNew.getTime() > currComparePriceList.startDate.dateValue.getTime() && endDateValueNew.getTime() < currComparePriceList.endDate.dateValue.getTime())
                {
                    indexToPush = indexToPush == -1 ? i + 1 : indexToPush;
                    var currComparePriceListCopy = JSON.parse(JSON.stringify(currComparePriceList));
                    for (var k = 0; k < currComparePriceListCopy.priceListItems.length; k++)
                    {
                        currComparePriceListCopy.priceListItems[k].id = 0;
                    }
                    currComparePriceListCopy.endDate.dateValue =  currComparePriceList.endDate.dateValue;
                    currComparePriceListCopy.startDate.dateValue = null;

                    var newEndDateOld = new Date(startDateValueNew);
                    newEndDateOld.setDate(startDateValueNew.getDate() - 1);
                    currComparePriceList.endDate.dateValue = newEndDateOld;

                    var newStartDateOld = new Date(endDateNew);
                    newStartDateOld.setDate(endDateNew.getDate() +1);
                    currComparePriceListCopy.startDate.dateValue = newStartDateOld;

                    priceGroup.priceLists.splice(i + 1, 0, currComparePriceListCopy);
                }
            }
        }
        //priceGroup.priceLists.push($scope.priceListCopy);

        if (indexToPush > -1)
        {
            priceGroup.priceLists.splice(indexToPush, 0, $scope.priceListCopy);
        }
        else
        {
            priceGroup.priceLists.push($scope.priceListCopy);
        }
        $mdDialog.hide();
    };
}